import dayjs from "dayjs"

function convertTime(
  twentyFourHourFormat: string,
  seperator = ":",
  format = "hA"
) {
  // Create an array from hh:mm:ss time format as [hh,mm,ss]
  if (twentyFourHourFormat) {
    const arrayTime = twentyFourHourFormat.split(seperator)

    // Create a timestamp from the above array
    const timeStamp = dayjs()
      .set("hours", Number(arrayTime[0]))
      .set("minutes", Number(arrayTime[1]))
      .set("seconds", Number(arrayTime[2]))

    return timeStamp.format(format)
  }
}

export default convertTime
